import React from "react";
import { useHistory } from "react-router-dom";
import { Container, Box } from "@material-ui/core";
import { MinimalTopBar } from "components/MinimalTopBar";
import NotificationCard3 from "components/NotificationCard3";

export default function NotificationCard3View() {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Container maxWidth="sm">
      <MinimalTopBar onGoBack={handleGoBack} />
      <Box mt={3}>
        <NotificationCard3 />
      </Box>
    </Container>
  );
}